import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';

import type { ColorVariant } from '../types/common';

interface BayConfirmationModalProps {
	onClick: () => void;
	showConfirmModal: boolean;
	setShowConfirmModal: (show: boolean) => void;
	title: React.ReactNode;
	bodyText: React.ReactNode;
	submitButtonTitle?: string;
	submitButtonVariant?: ColorVariant;
	showFooterBorder?: boolean;
	cancelButtonTitle?: string;
	centered?: boolean;
	/** Shows a spinner on the submit button and blocks submit/cancel/close while the action runs. */
	loading?: boolean;
}

const BayConfirmationModal: React.FC<BayConfirmationModalProps> = ({
	onClick,
	showConfirmModal,
	setShowConfirmModal,
	title,
	bodyText,
	submitButtonTitle = 'Delete',
	submitButtonVariant = 'danger',
	showFooterBorder = false,
	cancelButtonTitle = 'Cancel',
	centered = false,
	loading = false,
}) => {
	return (
		<Modal
			className="confirm-modal"
			show={showConfirmModal}
			onHide={() => !loading && setShowConfirmModal(false)}
			centered={centered}
		>
			{/* The close (X) is hidden while loading, so there is no enabled control that silently does nothing. */}
			<Modal.Header closeButton={!loading}>
				<Modal.Title>{title}</Modal.Title>
			</Modal.Header>
			<Modal.Body className="p-0 px-5 pb-4">{bodyText}</Modal.Body>
			<Modal.Footer className={showFooterBorder ? '' : 'border-top-0'}>
				<Button
					disabled={loading}
					variant="outline-secondary"
					onClick={() => setShowConfirmModal(false)}
				>
					{cancelButtonTitle}
				</Button>
				<Button aria-busy={loading} className="d-flex align-items-center" disabled={loading} variant={submitButtonVariant} onClick={onClick}>
					{loading && <Spinner aria-hidden="true" className="me-2" size="sm" />}
					{submitButtonTitle}
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default BayConfirmationModal;
